import React, {useContext} from 'react';
import {useSelector} from 'react-redux';
import {useFormContext} from 'react-hook-form';
import DatePicker from 'react-datepicker';
import {enUS, ru} from 'date-fns/locale';
import 'react-datepicker/dist/react-datepicker.css';
import {FormFieldProps} from '@src/@types/components/Form';
import {IEmptyModel} from '@src/@interfaces/IEmptyModel';
import {parseDate, stringifyDate} from '@src/helpers/dates';
import {FormFieldDesignContext} from '@src/contexts/FormFieldDesignContext';
import classnames from '@src/helpers/classnames';
import trans from '@src/helpers/trans';
import {IReduxStoreState} from '@src/@interfaces';
import TriggerableField from '../utils/TriggerableField';

export default function DatePickerFieldWidget<Model extends IEmptyModel>(props: FormFieldProps<Model>) {
    const {getFieldState, formState, watch, setValue} = useFormContext<Model>();
    const [design] = useContext(FormFieldDesignContext);
    const currentLocale = useSelector((state: IReduxStoreState) => state.locale.locale);

    const fieldName: any = props.fieldName;
    const isInvalid = Boolean(getFieldState(fieldName, formState).error);
    const size = props.config.size || design.size;
    const value = watch(fieldName);
    const locale = {en: enUS, ru: ru}[currentLocale] ?? enUS;

    return <TriggerableField
            trigger={props.config.trigger}
            componentToRender={DatePicker}
            selected={value ? parseDate(value).toDate() : undefined}
            onChange={date => {
                setValue(fieldName, date ? stringifyDate(date as any) as any : null);
            }}
            wrapperClassName={classnames({'is-invalid': isInvalid})}
            className={classnames({
                'is-invalid': isInvalid,
                'form-control': !size,
                [`form-control-${size}`]: size,
                [props.config.cssClass ?? '']: props.config.cssClass,
            })}
            placeholderText={trans('Forms.enter_field', {field: props.label.toLowerCase()})}
            readOnly={props.config.readOnly === true || design.fieldsAreReadOnly || props.forceReadonly}
            disabled={props.config.disabled === true || design.fieldsAreDisabled || props.forceDisabled}
            id={props.id}
            showTimeInput={true}
            showTimeSelect={true}
            locale={locale}
            dateFormat="Pp"
            showPopperArrow={false}
            autoComplete="off"
    />;
}
